import { whenAll } from 'platform/shared/health-apps';
import {
  roleIsNotSponsor,
  roleIsSponsor,
  showSponsorDisabilityEntry,
  showSponsorDisabilityPrefill,
  showSponsorEntry,
  sponsorIsDeceased,
  sponsorIsLiving,
} from '../../utils/helpers';
import { sponsorPrefillPage } from '../../utils/pageBuilders';
import { blankSchema } from '../../definitions';
import deathInformation from '../sponsor/deathInformation';
import livingStatus from '../sponsor/livingStatus';
import otherTricare from './otherTricare';
import sectionOverview from './sectionOverview';
import sponsorDisabilityDeceased from './sponsorDisability.deceased';
import sponsorDisabilityLiving from './sponsorDisability.living';
import sponsorDisabilitySelf from './sponsorDisability.self';
import sponsorDisabilitySelfPrefill from './sponsorDisability.selfPrefill';
import sponsorInformation from './sponsorInformation';
import sponsorTricare from './sponsorTricare';
import EligibilitySummaryPage from '../../containers/EligibilitySummaryPage';

export const eligibilityPages = {
  eligibilityOverview: {
    path: 'eligibility-for-champva',
    title: 'Eligibility for CHAMPVA',
    ...sectionOverview,
  },
  ...sponsorPrefillPage({
    key: 'eligibilitySponsorPrefill',
    path: 'veteran-personal-information',
  }),
  eligibilitySponsorInfo: {
    path: 'veteran-information-eligibility',
    title: 'Veteran’s personal and identification information',
    depends: showSponsorEntry,
    ...sponsorInformation,
  },
  eligibilitySponsorDisabilityPrefill: {
    path: 'eligibility-sponsor-disability-prefill',
    title: 'Veteran’s service-connected disability',
    depends: showSponsorDisabilityPrefill,
    ...sponsorDisabilitySelfPrefill,
  },
  eligibilitySponsorDisability: {
    path: 'eligibility-sponsor-disability',
    title: 'Veteran’s service-connected disability',
    depends: whenAll(roleIsSponsor, showSponsorDisabilityEntry),
    ...sponsorDisabilitySelf,
  },
  eligibilitySponsorTricare: {
    path: 'eligibility-sponsor-tricare',
    title: 'Eligibility for TRICARE',
    depends: roleIsSponsor,
    ...sponsorTricare,
  },
  eligibilityLivingStatus: {
    path: 'veteran-life-status-eligibility',
    title: 'Veteran’s status',
    depends: roleIsNotSponsor,
    ...livingStatus,
  },
  eligibilityDeathInformation: {
    path: 'veteran-death-information-eligibility',
    title: 'Veteran’s death details',
    depends: sponsorIsDeceased,
    ...deathInformation,
  },
  eligibilityDeceasedWithDisability: {
    path: 'veteran-deceased-disability-eligibility',
    title: 'Veteran’s service-connected disability',
    depends: sponsorIsDeceased,
    ...sponsorDisabilityDeceased,
  },
  eligibilityLivingWithDisability: {
    path: 'veteran-living-disability-eligibility',
    title: 'Veteran’s service-connected disability',
    depends: whenAll(roleIsNotSponsor, sponsorIsLiving),
    ...sponsorDisabilityLiving,
  },
  eligibilityOtherTricare: {
    path: 'eligibility-for-tricare',
    title: 'Eligibility for TRICARE',
    depends: roleIsNotSponsor,
    ...otherTricare,
  },
  eligibilitySummary: {
    path: 'eligibility-summary',
    title: 'Eligibility summary',
    CustomPage: EligibilitySummaryPage,
    CustomPageReview: null,
    uiSchema: {},
    schema: blankSchema,
  },
};
